import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";

import { useLocation } from "@reach/router";
import {
  updateParentUrl,
  webBridge,
} from "../../bridges/BridgeMethods/InitializeWeb";
import {
  fetchAppInfo,
  ingestData,
  isWeb,
} from "../../bridges/BridgeServices";
import { BRIDGE_NAME } from "../../bridges/bridgeConstants";
import { bridgeHandler } from "../../bridges/bridgeManager";
import { ticketsUrl } from "../../bridges/deeplinkUrlConfig";
import useGetIVRDetails from "../../hooks/useGetIVRDetails";
import { EVENTS } from "../../utils/constants";
import { isTokenPresent } from "../../utils/cookieHelper";
import GlobalChatBot from "../GlobalChatBot/globalChatBot";
import SearchInput from "../SearchInput/searchInput";
import TalkToUsModal from "../TalkToUsModal/talkToUsModal";
import Seo from "../seo";
import LoginHeader from "./LoginHeader";
import "./header.scss";
const Header = ({
  title,
  description,
  searchData,
  inputData = "",
  pageURI,
}) => {
  const location = useLocation();
  const ivrData = useGetIVRDetails();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    window[BRIDGE_NAME] = bridgeHandler;
    if (isWeb()) {
      webBridge();
      fetchAppInfo();
    }
  }, []);

  useEffect(() => {
    if (isWeb()) {
      updateParentUrl({
        url: location.pathname.replace("/support", ""),
      });
    }
  }, [location.pathname]);

  return (
    <>
      <Toaster position="bottom-center" />
      <div className="header-container">
        <Seo
          title={title || "PhonePe"}
          description={description}
          pageURI={pageURI}
        />
        {isWeb() && !isTokenPresent() && <LoginHeader />}
        {isWeb() && (
          <div className="header">
            <p className="header-heading">Help Center</p>

            <div className="search-bar-container">
              <SearchInput
                name="stockSearch"
                onSearch={() => {}}
                onClear={() => {}}
                autoComplete="off"
                data={searchData}
                inputData={inputData}
              />
              {isTokenPresent() && (
                <div className="btn-container">
                  {/* {ivrData?.isEnabled && (
                    <button
                      className="talk-to-us"
                      onClick={() => {
                        setIsOpen(true);
                        ingestData({
                          name: EVENTS.TALK_TO_US_CLICKED,
                          data: {
                            active: ivrData?.isEnabled,
                            faqTitle: title,
                          },
                        });
                      }}
                    >
                      TALK TO US
                    </button>
                  )} */}
                  <a
                    className="view-tickets"
                    href={ticketsUrl}
                    target="_blank"
                    onClick={e => {
                      if (
                        !window?.appInfoMeta
                          ?.hasFaqLoggedOut
                      ) {
                        toast.error(
                          "Something went wrong! Please logout and try again."
                        );
                        e.preventDefault();
                      }
                      ingestData({
                        name:
                          EVENTS.HELP_CENTER_VIEW_TICKET,
                      });
                    }}
                  >
                    VIEW TICKETS
                  </a>
                  <div className="contact-support">
                    <GlobalChatBot
                      supportBtnClassName="desktop-contact-support"
                      faqTitle={title}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {isWeb() && ivrData && (
        <TalkToUsModal
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
          }}
          data={ivrData}
        />
      )}
    </>
  );
};

export default Header;
